import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { costOfInaction } from '../data/content';
import { Accent, SectionHeading } from './SectionHeading';
export function CostSection() {
  return <section className="w-full bg-cream-100 px-6 pb-14 sm:pb-16" aria-labelledby="costo-titulo" data-id="element-17" data-mp="4kg2sq7393to">
      <div className="mx-auto max-w-5xl" data-id="element-18" data-mp="3vs0wgw06mkk9">
        <SectionHeading id="costo-titulo" badge="El costo de no tenerlo" badgeIcon={AlertTriangleIcon} title={<>
              Sin el Kit Instrumentación Industrial <Accent data-id="element-20" data-mp="3msxexwgnyd7v">perdés:</Accent>
            </>} data-id="element-19" data-mp="3vr92tqq5awwm" />

        <ul className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-21" data-mp="3hsj64c78mz8s">
          {costOfInaction.map(({
          icon: Icon,
          title,
          description
        }) => <li key={title} className="flex h-full flex-col rounded-xl border border-cream-300/70 bg-cream-50 p-4" data-id="element-22" data-mp="1g0d2n9ggt85o">
              <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-forest-700" data-id="element-23" data-mp="1b1th3a5s9ydu">
                <Icon className="h-3.5 w-3.5 text-ember-400" aria-hidden="true" data-id="element-24" data-mp="p60aakc5ziex" />
              </span>
              <h3 className="mt-3 text-sm font-semibold leading-tight text-forest-800" data-id="element-25" data-mp="taq505v36qy9">{title}</h3>
              <p className="mt-2 text-[0.8rem] leading-relaxed text-forest-700/70" data-id="element-26" data-mp="fayl5ohw2gcc">{description}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}